import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  usePurchasePriceOnRequestCondition,
  useWebViewManualAndInternationalAddress,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const webViewPropertyOwnerApartmentSellSchema: ValidationSchema = {
  address: useWebViewManualAndInternationalAddress,
  basicInfo: {
    room: validationRules.room,
    livingSpace: validationRules.livingSpace,
  },
  costs: {
    price: usePurchasePriceOnRequestCondition,
    rentSubsidy: validationRules.rentSubsidy,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  objectDetails: {
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
  },
  otherFacilities: {
    rentalIncome: validationRules.rentalIncome,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
